import { useCurrency, CurrencySelector, CurrencyNotice } from "../currency/Currency";
import React, { useEffect, useState } from "react";
import logo from "../Asset/Technogenius-logo.png";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { UserInfo, cartItems } from "./atoms/atoms";
import EditProfile from "./EditProfile";
import "../store-header.css";
import StaffLink from "../admin/StaffLink";

export default function Navbar() {
  const { money, currency } = useCurrency();
  const [user, setUser] = useRecoilState(UserInfo);
  const cart = useRecoilValue(cartItems);
  const location = useLocation();
  const navigate = useNavigate();
  const [term, setTerm] = useState("");
  const [open, setOpen] = useState(false);
  const [profile, setProfile] = useState(false);
  useEffect(() => {
    setOpen(false);
    setTerm(
      location.pathname === "/products"
        ? new URLSearchParams(location.search).get("q") || ""
        : ""
    );
  }, [location.pathname, location.search]);
  const count = cart.reduce(
    (sum, item) =>
      sum +
      (Number.isSafeInteger(item.quantity) && item.quantity > 0
        ? item.quantity
        : 0),
    0
  );
  const cents = cart.reduce(
    (sum, item) =>
      sum +
      (Number.isFinite(item.price) &&
      item.price >= 0 &&
      Number.isSafeInteger(item.quantity) &&
      item.quantity > 0
        ? Math.round(item.price * 100) * item.quantity
        : 0),
    0
  );
  const total = money(cents / 100);
  return (
    <header className="store-header">
      <div className="sh-service">
        Parts, accessories & technical support{" "}
        <span>Free store pickup · Card or bank transfer</span>
      </div>
      <div className="sh-top">
        <Link to="/" className="sh-logo" aria-label="Technogenious home">
          <img src={logo} alt="Technogenious Solutions" />
        </Link>
        <form
          className="sh-search"
          role="search"
          aria-label="Store search"
          onSubmit={(e) => {
            e.preventDefault();
            const query = term.trim();
            navigate(
              query ? `/products?q=${encodeURIComponent(query)}` : "/products"
            );
          }}
        >
          <input
            type="search"
            aria-label="Search products"
            placeholder="Search parts & accessories"
            value={term}
            maxLength={200}
            onChange={(e) => setTerm(e.target.value)}
          />
          <button type="submit">Search</button>
        </form>
        <CurrencySelector compact />
        <Link
          to="/cart"
          className="sh-cart"
          aria-label={`Cart, ${count} ${
            count === 1 ? "item" : "items"
          }, ${total} ${currency}`}
        >
          <span>
            Cart <b>{count}</b>
          </span>
          <small>
            {total} {currency}
          </small>
        </Link>
      </div>
      <CurrencyNotice />
      <div className="sh-nav-wrap">
        <button
          className="sh-toggle"
          aria-expanded={open}
          aria-controls="store-navigation"
          onClick={() => setOpen(!open)}
        >
          {open ? "Close menu" : "Menu ☰"}
        </button>
        <nav
          id="store-navigation"
          className={`sh-nav ${open ? "sh-open" : ""}`}
          aria-label="Main navigation"
          onKeyDown={(e) => {
            if (e.key === "Escape") setOpen(false);
          }}
        >
          <NavLink to="/" end>
            Home
          </NavLink>
          <NavLink
            to="/products"
            className={({ isActive }) =>
              `sh-shop-link ${
                isActive ||
                location.pathname.startsWith("/shop/") ||
                location.pathname.startsWith("/product/")
                  ? "active"
                  : ""
              }`
            }
          >
            Shop products <span aria-hidden="true">↗</span>
          </NavLink>
          <NavLink to="/gaming-machines">Gaming machines</NavLink>
          <NavLink to="/leasing">Leasing</NavLink>
          <NavLink to="/services">Services</NavLink>
          <NavLink to="/about">About us</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          <StaffLink token={user?.access_token} />
          {user ? (
            <details className="sh-dropdown sh-account">
              <summary>{user.user?.fullName || "My account"}</summary>
              <div>
                <button
                  onClick={() => {
                    navigate("/account");
                    setOpen(false);
                  }}
                >
                  Edit profile
                </button>
                <button onClick={()=>{navigate("/orders");setOpen(false);}}>My orders & invoices</button>
                <button
                  onClick={() => {
                    setUser(null);
                    setOpen(false);
                  }}
                >
                  Sign out
                </button>
              </div>
            </details>
          ) : (
            <div className="sh-account">
              <Link to="/login">Sign in</Link>
              <Link to="/register">Create account</Link>
            </div>
          )}
        </nav>
      </div>
      {profile && (
        <EditProfile
          showDialog={profile}
          onCloseDialog={() => setProfile(false)}
        />
      )}
    </header>
  );
}
